import api from "../api";

// QC Inspections 
export const getQCInspections = (params) =>
 api.get("/qc", { params });

export const getQCInspection = (id) =>
 api.get(`/qc/${id}`);

export const createQCInspection = (data) =>
 api.post("/qc", data, {
 headers: { "Content-Type": "multipart/form-data" },
 });

export const updateQCInspection = (id, data) =>
 api.patch(`/qc/${id}`, data, {
 headers: { "Content-Type": "multipart/form-data" },
 });

export const deleteQCInspection = (id) =>
 api.delete(`/qc/${id}`);

// Workflow 
export const approveQCInspection = (id, data) =>
 api.patch(`/qc/${id}/approve`, data);

export const rejectQCInspection = (id, data) =>
 api.patch(`/qc/${id}/reject`, data);

export const updateObservation = (id, obsId, data) =>
 api.patch(`/qc/${id}/observations/${obsId}`, data);

// Stats & Reports 
export const getQCStats = (params) =>
 api.get("/qc/stats", { params });

export const generateQCReport = (params) =>
 api.get("/qc/report", { params });

// NCR 
export const getNCRList = (params) =>
 api.get("/qc/ncr", { params });

export const closeNCR = (id, data) =>
 api.patch(`/qc/${id}/ncr-close`, data, {
 headers: { "Content-Type": "multipart/form-data" },
 });
